import { SvgIcon, SvgIconProps } from '@mui/material';
import { white } from '@/lib/colours';

export function NotificationsIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="notifications" clipPath="url(#clip0_941_42702)">
          <path
            id="Vector"
            d="M12.0005 22C13.1005 22 14.0005 21.1 14.0005 20H10.0005C10.0005 21.1 10.8905 22 12.0005 22ZM18.0005 16V11C18.0005 7.93 16.3605 5.36 13.5005 4.68V4C13.5005 3.17 12.8305 2.5 12.0005 2.5C11.1705 2.5 10.5005 3.17 10.5005 4V4.68C7.63054 5.36 6.00054 7.92 6.00054 11V16L4.71054 17.29C4.08054 17.92 4.52054 19 5.41054 19H18.5805C19.4705 19 19.9205 17.92 19.2905 17.29L18.0005 16Z"
            fill="currentcolor"
          />
        </g>
        <defs>
          <clipPath id="clip0_941_42702">
            <rect width="24" height="24" fill={white[900]} />
          </clipPath>
        </defs>
      </svg>
    </SvgIcon>
  );
}
